import React, { useEffect } from 'react';
import './Quality.css';

// Import quality images
import qualitySourcingImg from '../assets/images/quality/careful_sourcing.jpg';
import qualityProcessingImg from '../assets/images/quality/product_handling.jpg';
import qualityPackagingImg from '../assets/images/quality/packaging.jpg';
import qualityMindsetImg from '../assets/images/quality/mindset.jpg';
import qualityBannerImg from '../assets/images/quality/banner.jpg';

const Quality = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const qualitySections = [
    {
      id: 1,
      title: 'Careful Sourcing',
      image: qualitySourcingImg,
      text: 'We carefully source our products from trusted farmers and suppliers, ensuring freshness and consistency from the very beginning.',
      imagePosition: 'left'
    },
    {
      id: 2,
      title: 'Product Handling & Processing',
      image: qualityProcessingImg,
      text: 'Each product is handled with attention to cleanliness, hygiene, and natural preservation to maintain its original quality.',
      imagePosition: 'right'
    },
    {
      id: 3,
      title: 'Export-Oriented Packaging',
      image: qualityPackagingImg,
      text: 'Our products are packed to meet international transport requirements, ensuring safety and shelf stability during export.',
      imagePosition: 'left'
    },
    {
      id: 4,
      title: 'Quality Mindset',
      image: qualityMindsetImg,
      text: 'Quality is not a certificate for us—it is a daily practice across sourcing, handling, and delivery.',
      imagePosition: 'right'
    }
  ];

  return (
    <div className="quality-page">
      {/* Top Banner */}
      <div className="quality-banner">
        <div 
          className="quality-banner-image"
          style={{ backgroundImage: `url(${qualityBannerImg})` }}
        >
          <div className="quality-banner-overlay"></div>
          <div className="quality-banner-content">
            <h1 className="quality-banner-title">Quality You Can Trust</h1>
            <p className="quality-banner-subtitle">From Source to Shipment</p>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="quality-content">
        {qualitySections.map((section, index) => (
          <React.Fragment key={section.id}>
            <section className={`quality-section ${section.imagePosition}`}>
              <div className="quality-section-container">
                <div className="quality-section-image">
                  <img src={section.image} alt={section.title} />
                </div>
                <div className="quality-section-text">
                  <h2>{section.title}</h2>
                  <p>{section.text}</p>
                </div>
              </div>
            </section>
            {index < qualitySections.length - 1 && (
              <div className="quality-separator"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Quality;
